import './lib/jquery'

document.addEventListener('DOMContentLoaded', () => {
  const initialRadio = $('input[type="radio"]:checked')
  $('input:radio').change(function () {
    if (initialRadio[0].id === this.id) {
      $('.update-legitimization-type-btn').prop('disabled', true)
      $('.update-legitimization-type-btn').addClass('disabled')
    } else {
      $('.update-legitimization-type-btn').prop('disabled', false)
      $('.update-legitimization-type-btn').removeClass('disabled')
    }
  })
})
